/**
 * @generated SignedSource<<fabab3d3edd3d9f572732a97f864ca15>>
 * @relayHash 28f888dbec306fbacfd21d0432ea0a34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a64af9bcb3b0f6a95442ba53118ca740ad59465a60174124814a176d24aa2f7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6a64af9bcb3b0f6a95442ba53118ca740ad59465a60174124814a176d24aa2f7",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
